<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-sm-12 ">
        <div class="x_panel">
          <h2 class="float-left">Defer Job Report</h2>
          <div>
            <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
            <button  v-if="isPermissionExist(PERMISSIONS.DEFERRED_JOB_REPORT_PRINT)" @click="handleExportPrint()" :disabled="isPrinting" class="btn btn-warning btn-sm float-right">
              <i class="fa fa-print" v-if="!isPrinting"></i>
              <i class="fa fa-spinner fa-spin" v-if="isPrinting"></i>
              {{ isPrinting ? 'Printing...' : 'Print' }}
            </button>
            <vue-excel-xlsx
              v-if="isPermissionExist(PERMISSIONS.DEFERRED_JOB_REPORT_PRINT)"
              ref="excel"
              :data="excelData"
              :columns="excelHeader"
              :file-name="'Deffer Job List'"
              :file-type="'xlsx'"
              :sheet-name="'sheetname'"
              :disabled="isPrinting"
              class="btn btn-primary btn-sm float-right"
            >
              <div
                @click.prevent="handleExportPrint('excel')"
              >
                <i class="fa fa-file-excel-o"></i>
                {{ isPrinting ? 'Preparing...' : 'Excel' }}
              </div>
            </vue-excel-xlsx>
          </div>
        </div>

        <div class="">
          <div class="x_content ">
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body">
                      <div class="x_panel">
                        <div class="x_content">
                          <div class="row ">
                            <div class="col-md-2">
                              <div class="form-group">
                                <label>Vessel</label>
                                <select class="form-control" v-model="formData.vessel">
                                  <option value="" selected>Select Vessel</option>
                                  <option v-for="(row, key) in vessels" v-bind:value="{ id: row?.id, name: row?.name }">{{row?.name}}</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-2 mx-2">
                              <div class="form-group">
                                <label>Date From</label>
                                <DatePicker type="date" v-model="formData.dateFrom" valueType="format"></DatePicker>
                              </div>
                            </div>
                            <div class="col-md-2 mx-2">
                              <div class="form-group">
                                <label>Date To</label>
                                <DatePicker type="date" v-model="formData.dateTo" valueType="format"></DatePicker>
                              </div>
                            </div>
                            <div class="col-md-2">
                              <div class="form-group">
                                <label>Critical Jobs</label>
                                <select class="form-control" v-model="formData.critical_jobs">
                                  <option value>Select Critical Jobs</option>
                                  <option value="yes">Yes</option>
                                  <option value="no">No</option>
                                </select>
                              </div>
                            </div>

                            <div class="col-md-2">
                              <div class="form-group">
                                <label>Critical Components</label>
                                <select class="form-control" v-model="formData.critical_component">
                                  <option value>Select Critical Components</option>
                                  <option value="Yes">Yes</option>
                                  <option value="No">No</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-1">
                              <button style="margin-top: 26px" @click="getAllData" class=" btn-info btn btn-sm">Search</button>
                            </div>
                          </div>
                        </div>
                      </div>

                    <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
                      <PulseLoader :loading="loading"></PulseLoader>
                    </div>
                    <div class="card-box table-responsive" v-if="listData && !loading">
                      <div class="clearfix"></div>
                      <div>
                        <div class="mb-3 text-center">
                          <div class="font-weight-bold">Defer Job Report</div>
                          <div v-if="formData.vessel.name != ''">Vessel:
                            <span>{{formData.vessel.name}}  </span>
                          </div>
                          <div v-if="formData.dateFrom != '' && formData.dateTo !=''">
                            Date Period:
                            <span v-if="formData.dateFrom">{{ formData.dateFrom | moment('DD/MM/YYYY') }}</span> -
                            <span v-if="formData.dateTo"> {{ formData.dateTo | moment('DD/MM/YYYY') }}</span>
                          </div>
                        </div>
                        <PerPageSelector v-model="offset" @change="onPerPageChange"/>
                        <TableData :listData="listData?.data"
                                   :ApprovedByChiefEngineer="ApprovedByChiefEngineer"
                                   :ApproveByOffice="ApproveByOffice"
                                   :currentPage="Number(listData?.current_page)"
                                   :perPage="Number(listData?.per_page)"
                        />
                      </div>
                      <Pagination :pagination="listData" :getData="getAllData"/>

                      <div id="printArea" style="display: none">
                        <div style="text-align: center;line-height: 20px;">
                          <h2 style="line-height: 10px;">{{ appName }}</h2>
                          <div style="line-height: 10px;" class="font-weight-bold">Deferred Job Report</div>
                          <h3 style="line-height: 10px;">Vessel: <span v-if="formData.vessel">{{formData.vessel.name}}</span></h3>
                          <h3 style="line-height: 10px;" v-if="formData.dateFrom != '' && formData.dateTo !=''">
                            Date Period: <span v-if="formData.dateFrom">{{ formData.dateFrom | moment('DD/MM/YYYY') }}</span> -
                            <span v-if="formData.dateTo"> {{ formData.dateTo | moment('DD/MM/YYYY') }}</span>
                          </h3>
                          <p style="line-height: 10px;">Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>

                        </div>
                        <TableData :listData="printItems" :isPrinting="true"/>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>

    import auth from '../../../auth'
    import TableData from "./TableData.vue";
    import {apiPrintData, printUtil} from "@/utils/print";
    import printMixin from "@/mixin/printMixin";
    import goBackButtonMixin from "@/mixin/goBackButtonMixin";
    import exportMixin from "@/mixin/exportMixin";
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import DatePicker from "vue2-datepicker";
    import permissionsMixin from "@/mixin/permissionsMixin";

    export default {
        mixins: [printMixin, goBackButtonMixin, exportMixin, permissionsMixin],
        name: 'deferred-job-report',
        components: {
            TableData,
            PulseLoader,
            DatePicker
        },
        data() {
            return {
                appName: process.env.VUE_APP_NAME,
                loading: false,
                isPrinting: false,
                color: '#1ABB9C',
                size: '10px',
                listData: [],
                printItems: [],
                offset: 20,
                vessel_id: auth.getVesselId(),
                permissions: auth.getPermissionData(),
                vessels: null,
                formData: {
                    vessel: {
                        id:'',
                        name: ''
                    },
                    dateFrom: '',
                    dateTo: '',
                    critical_jobs: '',
                    critical_component: '',
                },
                pagination: {
                    current_page: 1,
                    offset: 5
                },
                excelHeader: [],
                excelData: []
            }
        },
        mounted() {
            this.getVessel();
            this.getAllData();
        },
        methods: {
            getVessel() {
              let params = {
                is_all: 1
              }
                this.$http.get('/api/vessel', {params}).then(response => {
                    this.vessels = response.data.success.vessel || [];
                    const selectedVessel = this.vessels.find(vessel => vessel.id == this.vessel_id);
                    if (selectedVessel) {
                      this.formData.vessel = {
                        id: selectedVessel.id,
                        name: selectedVessel.name
                      };
                    }
                }).catch(e => {
                    console.log(e)
                })
            },
            ApprovedByChiefEngineer(item) {
                // this.form1.busy = true;
                this.$http.get('/api/job-done-permission/' + item?.schedule_id + '/' + item?.id).then(response => {
                    this.$snotify.success('your permission Successfully Completed.');
                    this.getAllData();
                }).catch(e => {
                    console.log(e);
                    // var error=this.form.errors.errors.error;
                    this.$snotify.error('your permission Successfully is not  Completed.')
                })
            },
            ApproveByOffice(item) {
                // this.form1.busy = true;
                this.$http.get('/api/defer-reschedule-approve-office/' + item?.schedule_id + '/' + item?.id).then(response => {
                    this.$snotify.success('your permission Successfully Completed.');
                    this.getAllData();
                }).catch(e => {
                    console.log(e);
                    // var error=this.form.errors.errors.error;
                    this.$snotify.error('your permission Successfully is not  Completed.')
                })
            },
            onPerPageChange() {
              this.getAllData(1);
            },

          prepareExportData(dataList) {
            let rows = [];
            if (!dataList || !dataList) return rows;

            dataList.forEach((item, index) => {
              rows.push({
                '#': index + 1,
                'Job Name(Code)': `${item?.job_name || ''} (${item?.job_code || ''})`,
                'Department Name(Code)': `${item?.department || ''} (${item?.department_code || ''})`,
                'Component Name(Code)': `${item?.main_component || ''} - ${item?.component|| ''} - ${item?.sub_component|| ''}- ${item?.sub_sub_component|| ''}`,
                'Counter Type': `${item?.counter_type || ''}`,
                'Prev Maintenance Date': `${item?.prev_start_date || ''}`,
                'Next Maintenance Due Date': `${item?.prev_end_date || ''}`,
                'Defer Rescheduled Date': `${item?.current_end_date || ''}`,
                'Reason Deffer': `${item?.reason_deffer || ''}`,
                'Status': `${item?.status == 'Pending' ? 'Pending Approval' : item?.status}`,
              });
            });
            return rows;
          },

          excelExport(dataList) {
            let data = this.prepareExportData(dataList);
            if (!data || data.length === 0) {
              this.excelHeader = [];
              this.excelData = [];
              return;
            }

            // Build headers dynamically from the first row
            let excelHeader = Object.keys(data[0]).map(key => ({
              label: key,
              field: key
            }));

            this.excelHeader = excelHeader;
            this.excelData = data;
          },

          async handleExportPrint(type = 'print') {
            if (this.isPrinting) return

            this.isPrinting = true;

            try {
              const params = {
                vessel_id: this.formData.vessel_id,
                date_from: this.formData.dateFrom,
                date_to: this.formData.dateTo,
                critical_component: this.formData.critical_component,
                critical_jobs: this.formData.critical_jobs,
                is_all: 1,
              };

              const res = await this.$http.get('/api/filter/deferred-job', {params});
              const dataList = res?.data?.success ?? [];

              if (type === 'print'){
                this.printItems = dataList;
                this.$nextTick(() => {
                  apiPrintData('printArea', 'Deffer Job List');
                  this.isPrinting = false;
                });
              }

              if (type === 'excel'){
                this.excelExport(dataList);
                this.$nextTick(() => {
                  setTimeout(() => {
                    this.isPrinting = false;
                    this.$refs.excel.$el.click();
                  }, 200)
                });
              }

            } catch (error) {
              this.isPrinting = false;
              if (type == 'print') {
                printWindow.close();
              }
            }
          },

            getAllData(page = 1) {
                this.listData = [];
                this.loading = true;
                if (this.formData.vessel) this.formData.vessel_id = this.formData.vessel.id;
                let params = {
                    vessel_id: this.formData.vessel_id,
                    date_from: this.formData.dateFrom,
                    date_to: this.formData.dateTo,
                    critical_component: this.formData.critical_component,
                    critical_jobs: this.formData.critical_jobs,
                    is_all: 0,
                    offset: this.offset,
                    page: page
                };
                this.$http.get('/api/filter/deferred-job', {params}).then((response) => {
                  console.log(response)
                    this.listData = response.data.success;
                    this.loading = false;
                }).catch((e) => {
                    console.log(e);
                    this.loading = false;
                    let response = e.response;
                    if (response?.status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },
        }
    }
</script>

<style scoped>


</style>
